function isArray(o: any) {
    return Object.prototype.toString.call(o) === '[object Array]';
}

function getStateArrayAbbr() {
    return [
        { state_abbr: 'AB', state_text: 'AB' },
        { state_abbr: 'AK', state_text: 'AK' },
        { state_abbr: 'AL', state_text: 'AL' },
        { state_abbr: 'AR', state_text: 'AR' },
        { state_abbr: 'AZ', state_text: 'AZ' },
        { state_abbr: 'BC', state_text: 'BC' },
        { state_abbr: 'CA', state_text: 'CA' },
        { state_abbr: 'CO', state_text: 'CO' },
        { state_abbr: 'CT', state_text: 'CT' },
        { state_abbr: 'DC', state_text: 'DC' },
        { state_abbr: 'DE', state_text: 'DE' },
        { state_abbr: 'FL', state_text: 'FL' },
        { state_abbr: 'GA', state_text: 'GA' },
        { state_abbr: 'HI', state_text: 'HI' },
        { state_abbr: 'IA', state_text: 'IA' },
        { state_abbr: 'ID', state_text: 'ID' },
        { state_abbr: 'IL', state_text: 'IL' },
        { state_abbr: 'IN', state_text: 'IN' },
        { state_abbr: 'KS', state_text: 'KS' },
        { state_abbr: 'KY', state_text: 'KY' },
        { state_abbr: 'LA', state_text: 'LA' },
        { state_abbr: 'MA', state_text: 'MA' },
        { state_abbr: 'MB', state_text: 'MB' },
        { state_abbr: 'MD', state_text: 'MD' },
        { state_abbr: 'ME', state_text: 'ME' },
        { state_abbr: 'MI', state_text: 'MI' },
        { state_abbr: 'MN', state_text: 'MN' },
        { state_abbr: 'MO', state_text: 'MO' },
        { state_abbr: 'MS', state_text: 'MS' },
        { state_abbr: 'MT', state_text: 'MT' },
        { state_abbr: 'NB', state_text: 'NB' },
        { state_abbr: 'NC', state_text: 'NC' },
        { state_abbr: 'ND', state_text: 'ND' },
        { state_abbr: 'NE', state_text: 'NE' },
        { state_abbr: 'NH', state_text: 'NH' },
        { state_abbr: 'NJ', state_text: 'NJ' },
        { state_abbr: 'NL', state_text: 'NL' },
        { state_abbr: 'NM', state_text: 'NM' },
        { state_abbr: 'NS', state_text: 'NS' },
        { state_abbr: 'NT', state_text: 'NT' },
        { state_abbr: 'NU', state_text: 'NU' },
        { state_abbr: 'NV', state_text: 'NV' },
        { state_abbr: 'NY', state_text: 'NY' },
        { state_abbr: 'OH', state_text: 'OH' },
        { state_abbr: 'OK', state_text: 'OK' },
        { state_abbr: 'ON', state_text: 'ON' },
        { state_abbr: 'OR', state_text: 'OR' },
        { state_abbr: 'PA', state_text: 'PA' },
        { state_abbr: 'PE', state_text: 'PE' },
        { state_abbr: 'QC', state_text: 'QC' },
        { state_abbr: 'RI', state_text: 'RI' },
        { state_abbr: 'SC', state_text: 'SC' },
        { state_abbr: 'SD', state_text: 'SD' },
        { state_abbr: 'SK', state_text: 'SK' },
        { state_abbr: 'TN', state_text: 'TN' },
        { state_abbr: 'TX', state_text: 'TX' },
        { state_abbr: 'UT', state_text: 'UT' },
        { state_abbr: 'VA', state_text: 'VA' },
        { state_abbr: 'VT', state_text: 'VT' },
        { state_abbr: 'WA', state_text: 'WA' },
        { state_abbr: 'WI', state_text: 'WI' },
        { state_abbr: 'WV', state_text: 'WV' },
        { state_abbr: 'WY', state_text: 'WY' },
        { state_abbr: 'YT', state_text: 'YT' },
    ];
}

function stateArray() {
    return [
        { state_abbr: 'AL', state_text: 'Alabama' },
        { state_abbr: 'AK', state_text: 'Alaska' },
        { state_abbr: 'AZ', state_text: 'Arizona' },
        { state_abbr: 'AR', state_text: 'Arkansas' },
        { state_abbr: 'CA', state_text: 'California' },
        { state_abbr: 'CO', state_text: 'Colorado' },
        { state_abbr: 'CT', state_text: 'Connecticut' },
        { state_abbr: 'DE', state_text: 'Delaware' },
        { state_abbr: 'DC', state_text: 'District of Columbia' },
        { state_abbr: 'FL', state_text: 'Florida' },
        { state_abbr: 'GA', state_text: 'Georgia' },
        { state_abbr: 'HI', state_text: 'Hawaii' },
        { state_abbr: 'ID', state_text: 'Idaho' },
        { state_abbr: 'IL', state_text: 'Illinois' },
        { state_abbr: 'IN', state_text: 'Indiana' },
        { state_abbr: 'IA', state_text: 'Iowa' },
        { state_abbr: 'KS', state_text: 'Kansas' },
        { state_abbr: 'KY', state_text: 'Kentucky' },
        { state_abbr: 'LA', state_text: 'Louisiana' },
        { state_abbr: 'ME', state_text: 'Maine' },
        { state_abbr: 'MD', state_text: 'Maryland' },
        { state_abbr: 'MA', state_text: 'Massachusetts' },
        { state_abbr: 'MI', state_text: 'Michigan' },
        { state_abbr: 'MN', state_text: 'Minnesota' },
        { state_abbr: 'MS', state_text: 'Mississippi' },
        { state_abbr: 'MO', state_text: 'Missouri' },
        { state_abbr: 'MT', state_text: 'Montana' },
        { state_abbr: 'NE', state_text: 'Nebraska' },
        { state_abbr: 'NV', state_text: 'Nevada' },
        { state_abbr: 'NH', state_text: 'New Hampshire' },
        { state_abbr: 'NJ', state_text: 'New Jersey' },
        { state_abbr: 'NM', state_text: 'New Mexico' },
        { state_abbr: 'NY', state_text: 'New York' },
        { state_abbr: 'NC', state_text: 'North Carolina' },
        { state_abbr: 'ND', state_text: 'North Dakota' },
        { state_abbr: 'OH', state_text: 'Ohio' },
        { state_abbr: 'OK', state_text: 'Oklahoma' },
        { state_abbr: 'OR', state_text: 'Oregon' },
        { state_abbr: 'PA', state_text: 'Pennsylvania' },
        { state_abbr: 'RI', state_text: 'Rhode Island' },
        { state_abbr: 'SC', state_text: 'South Carolina' },
        { state_abbr: 'SD', state_text: 'South Dakota' },
        { state_abbr: 'TN', state_text: 'Tennessee' },
        { state_abbr: 'TX', state_text: 'Texas' },
        { state_abbr: 'UT', state_text: 'Utah' },
        { state_abbr: 'VT', state_text: 'Vermont' },
        { state_abbr: 'VA', state_text: 'Virginia' },
        { state_abbr: 'WA', state_text: 'Washington' },
        { state_abbr: 'WV', state_text: 'West Virginia' },
        { state_abbr: 'WI', state_text: 'Wisconsin' },
        { state_abbr: 'WY', state_text: 'Wyoming' },
        { state_abbr: 'AB', state_text: 'Alberta' },
        { state_abbr: 'BC', state_text: 'British Columbia' },
        { state_abbr: 'MB', state_text: 'Manitoba' },
        { state_abbr: 'NB', state_text: 'New Brunswick' },
        { state_abbr: 'NL', state_text: 'Newfoundland and Labrador' },
        { state_abbr: 'NS', state_text: 'Nova Scotia' },
        { state_abbr: 'ON', state_text: 'Ontario' },
        { state_abbr: 'PE', state_text: 'Prince Edward Island' },
        { state_abbr: 'QC', state_text: 'Quebec' },
        { state_abbr: 'SK', state_text: 'Saskatchewan' },
        { state_abbr: 'NT', state_text: 'Northwest Territories' },
        { state_abbr: 'NU', state_text: 'Nunavut' },
        { state_abbr: 'YT', state_text: 'Yukon' },
    ];
}

const commonUtilService: any = {
    isArray,
    stateArray,
    getStateArrayAbbr,
};

export default commonUtilService;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/services/commonUtil/commonUtilService.ts